<template>
  <div id="app relative">
    <div class="h-screen flex overflow-hidden bg-gray-50" @keydown.esc="sidebarOpen = false">
      <Sidebar v-if="user" :show="sidebarOpen" @close="sidebarOpen = false" />
      <div class="flex flex-col w-0 flex-1 overflow-hidden bg-gray-50">
        <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
          <button @click.stop="sidebarOpen = true"
            class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:bg-gray-200 transition ease-in-out duration-150">
            <svg class="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
        <main class="flex-1 relative z-0 overflow-y-auto pt-2 pb-6 focus:outline-none md:py-6" tabindex="0" ref="main">
          <transition name="fade" mode="out-in">
            <keep-alive>
              <slot />
            </keep-alive>
          </transition>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/dashboard/sidebar'

export default {
  name: 'DashboardLayout',
  inject: ['$user'],
  components: {
    Sidebar
  },
  data () {
    return {
      sidebarOpen: false
    }
  },
  computed: {
    user () {
      return this.$user()
    }
  },
  async mounted () {
    try {
      if (this.user.isAdmin) {
        this.$logger.info('Admin =====>')
        await this.$store.dispatch('prayerRequests/getAllPrayerRequests')
        await this.$store.dispatch('testimonies/getAllTestimonies')
        await this.$store.dispatch('categories/getCategories')
      } else if (this.user.isPastor) {
        this.$logger.info('Pastor =====>')
        await this.$store.dispatch('prayerRequests/getAllPrayerRequests')
        await this.$store.dispatch('categories/getCategories')
      } else if (this.user.isMember) {
        this.$logger.info('Member =====>')
        await this.$store.dispatch('prayerRequests/getUserPrayerRequests', this.user.id)
        await this.$store.dispatch('categories/getCategories')
      }
    } catch (error) {
      this.$logger.error('Error getting dashboard prayer requests', error)
      this.$sentry.captureException(error)
    }
  }
}
</script>

<style lang="scss">

.main {
  margin-top: 52px;
}
</style>
